//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      localSearchString: '',
      filters: {
        searchString: '',
        dateCreatedFrom: '',
        dateCreatedTo: '',
        currencyIdList: [],
        stakingLogTypeList: [constant.paramining.PARAMINING_LOG_TYPE.PERC_CHANGE],
      },
      constant,
    };
  },

  computed: {
    ...mapState('currencies', ['currencies']),
    ...mapState('stakingLogs', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({
      stakingLogTypeList: [constant.paramining.PARAMINING_LOG_TYPE.PERC_CHANGE],
    });
  },

  methods: {
    ...mapActions('stakingLogs', ['setFilters']),

    handleSearchBlur() {
      this.filters.searchString = this.localSearchString;
    },
  },
};
